/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

interface PushSetupChecklistModalArgs {
  showModal: boolean;
  title?: string;
  provider?: string;
  onClose(): () => unknown;
}

export default class PushSetupChecklistModal extends Component<PushSetupChecklistModalArgs> {
  @service analytics!: AnalyticsService;

  get showModal() {
    let { showModal } = this.args;

    if (showModal) {
      this._trackEvent();
    }

    return showModal;
  }

  @action
  close() {
    this.args.onClose();
  }

  _trackEvent() {
    let platform = this.args.title;
    if (platform) {
      this.analytics.track('push', 'setup_checklist_viewed', { platform: platform.toLowerCase() });
    }
  }
}
